module.exports = __webpack_public_path__ + "img/logo-boleto.757e966f.svg";